import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ToastComponent } from '../../shared/toast/toast.component';
import { setClassInvalid } from '../../shared/functions';
import { UserService } from '../../services/user.service';
import { departments, ee, sites } from '../../shared/constants';

@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss'],
  standalone: false
})
export class RegisterFormComponent {
  private router = inject(Router);
  private formBuilder = inject(UntypedFormBuilder);
  private userService = inject(UserService);
  toast = inject(ToastComponent);


  registerForm = this.createRegisterForm();
  inputPasswordType = 'password';
  departments = departments;
  sites = sites;
  setClassInvalid = setClassInvalid;

  createRegisterForm(): UntypedFormGroup {
    return this.formBuilder.group({
      firstName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(30)
      ])],
      lastName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(30)
      ])],
      email: ['', Validators.compose([
        Validators.required,
        Validators.email,
        Validators.minLength(3),
        Validators.maxLength(100)
      ])],
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(8)
      ])],
      department: ['', Validators.compose([
        Validators.required
      ])],
      site: ['', Validators.compose([
        Validators.required
      ])],
    });
  }

  changeContent(content: string): void {
    ee.emit('changeContent', content);
  }

  toggleInputPasswordType(): void {
    this.inputPasswordType = this.inputPasswordType === 'password' ? 'text' : 'password';
  }

  register(): void {
    this.userService.register(this.registerForm.value)
      .subscribe({
        next: res => {
          this.toast.setMessage('You successfully registered, check your email to verify your account.', 'success');
          this.router.navigate(['/login']);
        },
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
